import React from 'react';
import Gallery from './Gallery';
import { GalleryItem } from '../types/gallery';
import BusinessIntelligence from './home/BusinessIntelligence';
import WhatIsSnapfy from './home/WhatIsSnapfy';
import HomeDashboard from './home/HomeDashboard';
import SnapfyAssistant from './assistant/SnapfyAssistant';

// The home hero is now the Snapfy Assistant chat (it replaced the image generator).
// Props are kept optional so the router wiring (which still passes the legacy
// image-generation handlers) type-checks without changes; they are intentionally
// unused here.
interface HomePageProps {
    error?: string | null;
    isLoading?: boolean;
    homePageResult?: GalleryItem | null;
    prompt?: string;
    onPromptChange?: (prompt: string) => void;
    onGenerate?: (files: File[], generationPrompt: string, styleDetails: any, aspectRatio: string, resolution: string) => Promise<void>;
    onSelectStyle?: (stylePrompt: string) => void;
    onDownload?: (id: string, filename: string) => void;
    onEditImage?: (item: GalleryItem) => void;
    onStartVideoCreation?: (item: GalleryItem) => void;
}

const HomePage: React.FC<HomePageProps> = () => {
    return (
        <>
            {/* AI assistant hero — recommends the best Snapfy app for the user's goal.
                Full-width like the other home blocks. */}
            <section className="my-6 md:my-8 w-full">
                <SnapfyAssistant variant="embedded" />
            </section>

            {/* Home Page Sections — value-prop, "o futuro", explore apps, gallery showcase. */}
            <BusinessIntelligence />
            <WhatIsSnapfy />
            <HomeDashboard />

            <Gallery />
        </>
    );
};

export default HomePage;
